export default "__VITE_ASSET__DsrbuTj___"